"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosBlendRecipeUpdateInputSchema = exports.APosBlendRecipeCreateInputSchema = exports.APosBlendRecipeSchema = exports.APosBlendRecipeVisibilitySchema = exports.APosBlendRecipeRoundingStrategySchema = exports.APosBlendRecipePricingModeSchema = exports.APosBlendRecipeProductTypeSchema = exports.APosBlendRecipeTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
/**
 * Module 29 — Oil Blending
 * BlendRecipe — signature OR custom OR tweak.
 * PK = tenantId, SK = blendRecipeId (blend_{ulid12}).
 * GSIs: customer-index, type-index, parent-index.
 */
const decimal2dp = (val) => Number.isFinite(val) && Math.round(val * 100) / 100 === val;
const decimal3dp = (val) => Number.isFinite(val) && Math.round(val * 1000) / 1000 === val;
exports.APosBlendRecipeTypeSchema = zod_1.z.enum(['signature', 'custom']);
exports.APosBlendRecipeProductTypeSchema = zod_1.z.enum(['body_oil', 'essential_oil']);
exports.APosBlendRecipePricingModeSchema = zod_1.z.enum([
    'flat_per_bottle', 'ingredient_cost_plus', 'fixed_per_recipe', 'inherit',
]);
exports.APosBlendRecipeRoundingStrategySchema = zod_1.z.enum([
    'nearest_99', 'nearest_5', 'nearest_dollar',
]);
exports.APosBlendRecipeVisibilitySchema = zod_1.z.enum(['public', 'private']);
exports.APosBlendRecipeSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    blendRecipeId: id_schema_1.EntityIdSchema.describe('Format: blend_{ulid12}'),
    name: zod_1.z.string().min(1).max(80),
    blend_type: exports.APosBlendRecipeTypeSchema,
    product_type: exports.APosBlendRecipeProductTypeSchema,
    bottle_size_ml: zod_1.z.number().positive().refine(decimal3dp, 'must be 3dp'),
    // E.g. 15.0 = 15% fragrance / 85% carrier. Capped at 20% per safety.
    // Required when product_type='body_oil'. Optional for essential_oil (100% fragrance).
    total_fragrance_percent: zod_1.z.number().min(0).max(20).refine(decimal2dp, 'must be 2dp').optional(),
    carrier_oil_id: id_schema_1.EntityIdSchema.optional().describe('Required for body_oil; FK to CarrierOil'),
    purpose_tags: zod_1.z.array(zod_1.z.string()).optional(),
    mood_tags: zod_1.z.array(zod_1.z.string()).optional(),
    pricing_mode: exports.APosBlendRecipePricingModeSchema.optional(),
    fixed_price_cents: zod_1.z.number().int().nonnegative().optional(),
    markup_multiplier: zod_1.z.number().nonnegative().optional(),
    labor_charge_cents: zod_1.z.number().int().nonnegative().optional(),
    rounding_strategy: exports.APosBlendRecipeRoundingStrategySchema.optional(),
    supports_refill: zod_1.z.boolean().default(true),
    visibility: exports.APosBlendRecipeVisibilitySchema.default('private'),
    parent_recipe_id: id_schema_1.EntityIdSchema.optional().describe('If this is a tweak, points to source recipe'),
    version_number: zod_1.z.number().int().positive().default(1),
    created_by_customer_id: id_schema_1.EntityIdSchema.optional(),
    created_by_staff_id: id_schema_1.EntityIdSchema.optional(),
    times_purchased: zod_1.z.number().int().nonnegative().default(0),
    last_purchased_at: zod_1.z.number().optional().describe('Unix ms'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosBlendRecipeCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(80),
    blend_type: exports.APosBlendRecipeTypeSchema,
    product_type: exports.APosBlendRecipeProductTypeSchema,
    bottle_size_ml: zod_1.z.number().positive().refine(decimal3dp, 'must be 3dp'),
    total_fragrance_percent: zod_1.z.number().min(0).max(20).refine(decimal2dp, 'must be 2dp').optional(),
    carrier_oil_id: id_schema_1.EntityIdSchema.optional(),
    purpose_tags: zod_1.z.array(zod_1.z.string()).optional(),
    mood_tags: zod_1.z.array(zod_1.z.string()).optional(),
    pricing_mode: exports.APosBlendRecipePricingModeSchema.optional(),
    fixed_price_cents: zod_1.z.number().int().nonnegative().optional(),
    markup_multiplier: zod_1.z.number().nonnegative().optional(),
    labor_charge_cents: zod_1.z.number().int().nonnegative().optional(),
    rounding_strategy: exports.APosBlendRecipeRoundingStrategySchema.optional(),
    supports_refill: zod_1.z.boolean().optional(),
    visibility: exports.APosBlendRecipeVisibilitySchema.optional(),
    parent_recipe_id: id_schema_1.EntityIdSchema.optional(),
    created_by_customer_id: id_schema_1.EntityIdSchema.optional(),
    created_by_staff_id: id_schema_1.EntityIdSchema.optional(),
});
exports.APosBlendRecipeUpdateInputSchema = exports.APosBlendRecipeCreateInputSchema.partial();
//# sourceMappingURL=blend-recipe.schema.js.map